import { adminFetch } from './dataProvider';
import type { LeadTag, TagCategory } from './types';

export interface CustomTagDefinition {
  company_id: string;
  value:      string;
  created_at: string;
}

interface TagsResponse {
  tags: LeadTag[];
}

interface DefinitionsResponse {
  definitions: CustomTagDefinition[];
}

export async function fetchTagDefinitions(): Promise<CustomTagDefinition[]> {
  const body = await adminFetch<DefinitionsResponse>('/v1/admin/tag-definitions');
  return body.definitions;
}

export async function addTag(
  personId: string,
  category: TagCategory,
  value: string,
): Promise<LeadTag[]> {
  const body = await adminFetch<TagsResponse>(`/v1/admin/leads/${personId}/tags`, {
    method: 'POST',
    body: JSON.stringify({ category, value }),
  });
  return body.tags;
}

export async function removeTag(
  personId: string,
  category: string,
  value: string,
): Promise<LeadTag[]> {
  const body = await adminFetch<TagsResponse>(
    `/v1/admin/leads/${personId}/tags/${encodeURIComponent(category)}/${encodeURIComponent(value)}`,
    { method: 'DELETE' },
  );
  return body.tags;
}
